import React from 'react';
import PropTypes from 'prop-types';
import css from './UpcomingTime.css';
import moment from 'moment';
import 'moment-timezone';
import Icon from 'SF/MaterialIcon';
import { getDateFormat } from 'utils/time';

export default class UpcomingTime extends React.Component {

  get date() {
    return moment(this.props.startDate).format(getDateFormat('weekdayDateDisplayFormat'));
  }

  get timeRange() {
    const { startDate, timeZone, duration } = this.props;
    const startTime = moment(startDate).tz(timeZone).format(getDateFormat('timeDisplayFormat'));
    const endTime = moment(startDate).add(duration, 'minutes').tz(timeZone).format(getDateFormat('timeDisplayFormat'));
    return startTime + "–" + endTime;
  }

  render() {
    return (
      <div className={css['time-container']}>
        <div><Icon aria-label="Time" title="Time" icon="access_time" /></div>
        <div>
          <div className="date">{this.date}</div>
          <div className="timeRange">{this.timeRange}</div>
        </div>
      </div>
    );
  }
}

UpcomingTime.defaultProps = {
  timeZone: "America/New_York"
};

UpcomingTime.propTypes = {
  startDate: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  timeZone: PropTypes.string
};
